import axiosInstance from "../../../helpers/api";

export const getAllSubjectAssistPhones = (body) => {
    return axiosInstance.get('/admin/subject_assist_phones', body);
};

export const editSubjectAssistPhone = (formData) => {
    return axiosInstance.put(`/admin/subject_assist_phones/${formData.id}`, formData.formData);
};

export const createSubjectAssistPhone = (formData) => {
    return axiosInstance.post('/admin/subject_assist_phones', formData);
};

export const deleteSubjectAssistPhone = (id) => {
    return axiosInstance.delete(`/admin/subject_assist_phones/${id}`);
};

